import { NgIf, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom, switchMap } from 'rxjs/operators';

import { getSelectedCycleId } from '../../store/selectors/cycle.selectors';

@Component({
  selector: 'app-cycle-navigation',
  templateUrl: './cycle-navigation.component.html',
  imports: [NgIf, MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class CycleNavigationComponent {
  cycleId$: Observable<number> = this.store.select(getSelectedCycleId);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));

  // TODO: Remove this after tabs are added, this is used to show the correct tab when needed
  isDayOldChick$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('day-old-chick') > 0),
  );

  isDeparture$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('departure') > 0),
  );

  isSection$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('section') > 0));

  isBalance$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('balance') > 0));

  isClosure$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('closure') > 0));

  isOrders$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('orders') > 0));

  isArrivals$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('arrivals') > 0));

  isReports$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('reports') > 0));

  isMovements$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('movements') > 0),
  );

  isDepartures$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('departures') > 0),
  );

  isGeneral$: Observable<boolean> = this.isDayOldChick$.pipe(
    withLatestFrom(
      this.isDeparture$,
      this.isSection$,
      this.isBalance$,
      this.isClosure$,
      this.isOrders$,
      this.isArrivals$,
      this.isMovements$,
      this.isDepartures$,
      this.isReports$,
    ),
    switchMap(
      ([
        isDayOldChick,
        isSection,
        isDeparture,
        isBalance,
        isClosure,
        isOrders,
        isArrivals,
        isMovements,
        isDepartures,
        isReports,
      ]) => [
        !(
          isDayOldChick ||
          isSection ||
          isDeparture ||
          isBalance ||
          isClosure ||
          isOrders ||
          isArrivals ||
          isMovements ||
          isDepartures ||
          isReports
        ),
      ],
    ),
  );

  constructor(private readonly store: Store<RootState>) {}
}
